export default __webpack_public_path__ + "static/media/banner-governance-mobile.47545dcf.png";